(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["product-template"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('nl-product-description')) {
    customElements.define('nl-product-description', class extends HTMLElement {
      connectedCallback() {
        if (document.readyState === 'loading') {
          document.addEventListener('DOMContentLoaded', () => this.enhance(), { once: true });
        } else {
          queueMicrotask(() => this.enhance());
        }
      }

      enhance() {
        if (!this.isConnected || this.descriptionBound) return;
        const fold = this.querySelector('.nl-description-fold');
        if (!fold) return;
        this.descriptionBound = true;
        let wasOpen = fold.open;
        fold.addEventListener('toggle', () => {
          if (wasOpen && !fold.open) {
            const bounds = this.getBoundingClientRect();
            if (bounds.top < 0 || bounds.bottom > window.innerHeight) {
              this.scrollIntoView({ block: 'start', behavior: 'instant' });
            }
          }
          wasOpen = fold.open;
          this.dispatchEvent(new CustomEvent('nl:description:toggle', { bubbles: true }));
        });
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
